import '../../capabilities/registry';
import { registerDeployPlugin } from '../../core/registry';
import { registerResourceConfigs } from '../../platform/resource-watch';
import { registerSkuModuleMeta } from '../../platform/scene-layout/moduleMetaRegistry';
import { MI_CAPABILITIES } from './capabilities';
import { miHeadless } from './headless';
import { MI_MODULES } from './modules';
import { MI_RESOURCE_CONFIGS, MI_SKU_MODULE_META } from './resourceConfigs';

registerSkuModuleMeta('ModelInstance', MI_SKU_MODULE_META);
registerResourceConfigs('ModelInstance', MI_RESOURCE_CONFIGS);

registerDeployPlugin({
  headless: miHeadless,
  loadUi: () =>
    import('./ui').then((m) => ({
      ResourceEditor: m.MiResourceEditor,
      ResourcePreview: m.MiResourcePreview,
    })),
});

export { MI_LINKAGE_RULES, useMiDeployFormLinkage } from './linkage';
export type { MiLinkagePropsMap } from './linkage';
export type { MiFieldKey } from './fields';
export type { MiOrderFoldSection, MiOrderModuleKey, MiOrderNodeGroupsSegment, MiSkuModuleKey } from './scenes';
export { resetMiSkuModuleFields } from './skuModuleReset';
export {
  MI_SKU_MODULE_KEYS,
  MI_SKU_MODULE_LIST,
  MI_ORDER_MODULE_KEYS,
  MI_ORDER_MODULE_LIST,
  MI_DIRECT_CREATE_STEPS,
  MI_DIRECT_MERGED_MODULES,
  MI_ORDER_DELIVERY_RUNTIME,
  MI_ORDER_MODULE_TITLE,
  filterMiSkuModules,
  filterMiDirectMergedModules,
  filterMiDirectResourceStepModuleKeys,
  resolveMiOrderFoldSections,
  resolveModelInstancePdSeparation,
  isModelInstancePresetPdSeparation,
  hasModelInstancePdSegmentPreset,
  MI_RESOURCE_STEP_EXCLUDED_MODULE_KEYS,
} from './scenes';
export { buildMiFreshDisplayConfig } from './display';
export { buildMiMergedDisplayConfig, finalizeMiSubmitDisplayConfig } from './display/mergeDisplayConfig';
export { MI_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS, filterMiProductCardDisplayConfig } from './display/productCard';
export { buildMiSkuCapabilityOptions } from './skuCapabilityOptions';
export { filterModelInstanceTypeOptions } from './modelInstanceRuntimeOptions';
export { buildMiEmbeddedNodeGroupsCapabilityOptions, buildTcEmbeddedNodeGroupsCapabilityOptions } from './embeddedNodeGroupsOptions';
export { resolveMiModuleTitle, buildMiNodeGroupsDrawerDescOptions, buildTcNodeGroupsDrawerDescOptions } from './resolveMiModuleTitle';
export type { ResolveMiModuleTitleOptions, MaasNodeGroupsDrawerDescOptions } from './resolveMiModuleTitle';
export {
  resolveMiOrderPreviewExtraWatchFields,
  resolveMiSkuPreviewExtraWatchFields,
  resolveMiOrderInnerRootWatchFields,
} from './orderPreviewWatch';
export { MI_RESOURCE_CONFIGS, MI_SKU_MODULE_META } from './resourceConfigs';
export { MiResourceEditor } from './ui/ResourceEditor';
export type { MiResourceEditorProps } from './ui/ResourceEditor';
export { MiResourcePreview } from './ui/ResourcePreview';
export { ScriptEnvVarsHint } from './ui/script-env-vars-hint';
export { SCRIPT_ENV_VAR_GROUPS, MI_SCRIPT_ENV_VAR_GROUPS } from './ui/script-env-vars-hint';
export type { ScriptEnvVarGroup, ScriptEnvVarItem } from './ui/script-env-vars-hint';
export {
  buildMiDeliveryMetadata,
  buildMiOrderDeliveryMetadata,
  buildModelInstanceOrderDeliveryMetadataBody,
} from './headless/deliveryMetadata';
export type {
  BuildMiDeliveryMetadataInput,
  BuildMiOrderDeliveryMetadataContext,
  ModelInstanceDeliveryMetadata,
} from './headless/deliveryMetadata';
export { hydrateModelInstanceDetailToForm, getModelSizeGi } from './hydrateFromApiDetail';
export {
  formToPayload,
  getModelSizeStorageMismatchErrorKey,
  getModelSourceType,
  prepareModelInstanceSubmit,
  readModelInstanceSpecFromForm,
  sanitizeModelSource,
  serializeModelForApi,
  validateMaasStorage,
} from './headless/payload';
export { confirmModelInstanceImageOnForm } from './headless/imageConfirm';
export { assertModelInstanceUniqueNodeGroupNamesOnForm, getModelInstanceUniqueNodeGroupNamesError } from './headless/submitValidate';
export { resolveMiSkuPreviewModuleKeys } from './resolveMiSkuPreviewModuleKeys';
/** 直建提交包装（含异步 GPU 校验）；校验通过后 body 与 pipeline.buildSubmitPayload 同源 */
export { prepareModelInstanceSubmit as buildModelInstanceDirectSubmit } from './headless/payload';
export { MI_MODULES, MI_MODULE_MAP } from './modules';
export { MI_CAPABILITIES } from './capabilities';
export {
  SERVICE_MOUNT_GROUP_NAME_FIELD,
  buildServiceMountNodeOptions,
  formatServiceMountGroupNamesDisplay,
  normalizeServiceMountGroupNames,
  resolveServiceMountGroupNamesFromServices,
} from './serviceMountNode';
export {
  buildMiServiceMountNodeOptions,
  buildMiServiceMountNodeOptionsFromSpec,
  formatMiServiceMountGroupNameDisplay,
  formatMiServiceMountGroupNamesDisplay,
  formatMiServiceMountGroupNamesFromServices,
  formatMiServiceMountGroupNamesFromWorkload,
} from './inferenceServiceMount';
export { ModelInstanceServiceFields } from './ui/ModelInstanceServiceFields';
export type { ModelInstanceServiceFieldsProps } from './ui/ModelInstanceServiceFields';
export { MiReplicasSection } from './ui/MiReplicasSection';
export type { MiReplicasSectionProps } from './ui/MiReplicasSection';
export { MiInferenceNodeGroupsReadonly } from './ui/MiInferenceNodeGroupsReadonly';
export type { MiInferenceNodeGroupsReadonlyProps } from './ui/MiInferenceNodeGroupsReadonly';
export { MiInferenceDeployModeField, formatMiInferenceDeployModeLabel } from './ui/MiInferenceDeployModeField';
export type { MiInferenceDeployModeFieldProps } from './ui/MiInferenceDeployModeField';
export {
  clearModelInstancePdSegmentFields,
  ensureModelInstanceKvOffloadDefaults,
  ensureModelInstanceNormalTopologyDefaults,
  ensureModelInstancePdSegmentDefaults,
  restoreMiSkuModuleDefaults,
} from './inferencePdFormFields';
export { MiInferenceNodeModules } from './ui/MiInferenceNodeModules';
export type { MiInferenceNodeModulesProps, MiInferenceNodeSegment } from './ui/MiInferenceNodeModules';
export { buildModelInstanceApiRequestBody } from './headless/modelInstanceApiBody';
